export const getAppointmentBookedTimeZoneStorageKey = (appointmentId: string) =>
  `lh_patient:appt_booked_timezone_${appointmentId}`;

export const allTimeZonesDetails = [
  {
    abbreviation: 'ACDT',
    name: 'Australian Central Daylight Saving Time',
    offset: 'UTC+10:30',
  },
  {
    abbreviation: 'ACST',
    name: 'Australian Central Standard Time',
    offset: 'UTC+09:30',
  },
  {
    abbreviation: 'ACT',
    name: 'Acre Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'ACT',
    name: 'ASEAN Common Time',
    offset: 'UTC+08:00',
  },
  {
    abbreviation: 'ACWST',
    name: 'Australian Central Western Standard Time',
    offset: 'UTC+08:45',
  },
  {
    abbreviation: 'ADT',
    name: 'Atlantic Daylight Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'AEDT',
    name: 'Australian Eastern Daylight Saving Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'AEST',
    name: 'Australian Eastern Standard Time',
    offset: 'UTC+10',
  },
  {
    abbreviation: 'AET',
    name: 'Australian Eastern Time',
    offset: 'UTC+10/UTC+11',
  },
  {
    abbreviation: 'AFT',
    name: 'Afghanistan Time',
    offset: 'UTC+04:30',
  },
  {
    abbreviation: 'AKDT',
    name: 'Alaska Daylight Time',
    offset: 'UTC-08',
  },
  {
    abbreviation: 'AKST',
    offset: 'UTC-09',
    name: 'Alaska Standard Time',
  },
  {
    abbreviation: 'ALMT',
    name: 'Alma-Ata Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'AMST',
    name: 'Amazon Summer Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'AMT',
    name: 'Amazon Standard Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'AMT',
    name: 'Armenia Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'ANAT',
    name: 'Anadyr Standard Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'AQTT',
    name: 'Aqtobe Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'ART',
    offset: 'UTC-03',
    name: 'Argentina Standard Time',
  },
  {
    abbreviation: 'AST',
    name: 'Arabian Standard Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'AST',
    offset: 'UTC-04',
    name: 'Atlantic Standard Time',
  },
  {
    abbreviation: 'AWST',
    name: 'Australian Western Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'AZOST',
    name: 'Azores Summer Time',
    offset: 'UTC±00',
  },
  {
    abbreviation: 'AZOT',
    name: 'Azores Standard Time',
    offset: 'UTC-01',
  },
  {
    abbreviation: 'AZT',
    name: 'Azerbaijan Time',
    offset: 'UTC-01',
  },
  {
    abbreviation: 'BNT',
    name: 'Brunei Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'BIOT',
    name: 'British Indian Ocean Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'BIT',
    name: 'Baker Island Time',
    offset: 'UTC-12',
  },
  {
    abbreviation: 'BOT',
    name: 'Bolivia Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'BRST',
    name: 'Brasilia Summer Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'BRT',
    offset: 'UTC-03',
    name: 'Brasilia Standard Time',
  },
  {
    abbreviation: 'BST',
    name: 'Bangladesh Standard Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'BST',
    name: 'Bougainville Standard Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'BST',
    name: 'British Summer Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'BTT',
    name: 'Bhutan Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'CAT',
    offset: 'UTC+02',
    name: 'Central Africa Time',
  },
  {
    abbreviation: 'CCT',
    name: 'Cocos Islands Time',
    offset: 'UTC+06:30',
  },
  {
    abbreviation: 'CDT',
    name: 'Central Daylight Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'CDT',
    name: 'Cuba Daylight Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'CEST',
    name: 'Central European Summer Time',
    offset: 'UTC+02',
  },
  {
    abbreviation: 'CET',
    name: 'Central European Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'CHADT',
    name: 'Chatham Daylight Time',
    offset: 'UTC+13:45',
  },
  {
    abbreviation: 'CHAST',
    name: 'Chatham Standard Time',
    offset: 'UTC+12:45',
  },
  {
    abbreviation: 'CHOT',
    name: 'Choibalsan Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'CHOST',
    name: 'Choibalsan Summer Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'CHST',
    name: 'Chamorro Standard Time',
    offset: 'UTC+10',
  },
  {
    abbreviation: 'CHUT',
    name: 'Chuuk Time',
    offset: 'UTC+10',
  },
  {
    abbreviation: 'CIST',
    name: 'Clipperton Island Standard Time',
    offset: 'UTC-08',
  },
  {
    abbreviation: 'CKT',
    name: 'Cook Island Time',
    offset: 'UTC-10',
  },
  {
    abbreviation: 'CLST',
    name: 'Chile Summer Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'CLT',
    name: 'Chile Standard Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'COST',
    name: 'Colombia Summer Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'COT',
    name: 'Colombia Standard Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'CST',
    name: 'Central Standard Time',
    offset: 'UTC-06',
  },
  {
    abbreviation: 'CST',
    name: 'China Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'CST',
    name: 'Cuba Standard Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'CT',
    name: 'Central Time',
    offset: 'UTC-06/UTC-05',
  },
  {
    abbreviation: 'CVT',
    name: 'Cape Verde Time',
    offset: 'UTC-01',
  },
  {
    abbreviation: 'CWST',
    name: 'Central Western Standard Time',
    offset: 'UTC+08:45',
  },
  {
    abbreviation: 'CXT',
    name: 'Christmas Island Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'DAVT',
    name: 'Davis Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'DDUT',
    name: "Dumont d'Urville Time",
    offset: 'UTC+10',
  },
  {
    abbreviation: 'DFT',
    name: 'AIX specific equivalent of Central European Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'EASST',
    name: 'Easter Island Summer Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'EAST',
    name: 'Easter Island Standard Time',
    offset: 'UTC-06',
  },
  {
    abbreviation: 'EAT',
    name: 'East Africa Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'ECT',
    name: 'Eastern Caribbean Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'ECT',
    name: 'Ecuador Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'EDT',
    name: 'Eastern Daylight Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'EEST',
    name: 'Eastern European Summer Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'EET',
    offset: 'UTC+02',
    name: 'Eastern European Standard Time',
  },
  {
    abbreviation: 'EGST',
    name: 'Eastern Greenland Summer Time',
    offset: 'UTC±00',
  },
  {
    abbreviation: 'EGT',
    name: 'Eastern Greenland Time',
    offset: 'UTC-01',
  },
  {
    abbreviation: 'EST',
    name: 'Eastern Standard Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'ET',
    name: 'Eastern Time',
    offset: 'UTC-05/UTC-04',
  },
  {
    abbreviation: 'FET',
    name: 'Further-eastern European Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'FJT',
    name: 'Fiji Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'FKST',
    name: 'Falkland Islands Summer Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'FKT',
    name: 'Falkland Islands Standard Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'FNT',
    name: 'Fernando de Noronha Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'GALT',
    name: 'Galápagos Time',
    offset: 'UTC-06',
  },
  {
    abbreviation: 'GAMT',
    name: 'Gambier Islands Time',
    offset: 'UTC-09',
  },
  {
    abbreviation: 'GET',
    name: 'Georgia Standard Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'GFT',
    name: 'French Guiana Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'GILT',
    name: 'Gilbert Island Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'GIT',
    name: 'Gambier Island Time',
    offset: 'UTC-09',
  },
  {
    abbreviation: 'GMT',
    name: 'Greenwich Mean Time',
    offset: 'UTC±00',
  },
  {
    abbreviation: 'GST',
    name: 'South Georgia and the South Sandwich Islands Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'GST',
    name: 'Gulf Standard Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'GYT',
    name: 'Guyana Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'HDT',
    name: 'Hawaii-Aleutian Daylight Time',
    offset: 'UTC-09',
  },
  {
    abbreviation: 'HST',
    offset: 'UTC-10',
    name: 'Hawaii-Aleutian Standard Time',
  },
  {
    abbreviation: 'HKT',
    name: 'Hong Kong Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'HMT',
    name: 'Heard and McDonald Islands Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'HOVST',
    name: 'Hovd Summer Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'HOVT',
    name: 'Hovd Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'ICT',
    name: 'Indochina Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'IDLW',
    name: 'International Day Line West time zone',
    offset: 'UTC-12',
  },
  {
    abbreviation: 'IDT',
    name: 'Israel Daylight Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'IOT',
    name: 'Indian Ocean Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'IRDT',
    name: 'Iran Daylight Time',
    offset: 'UTC+04:30',
  },
  {
    abbreviation: 'IRKT',
    name: 'Irkutsk Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'IRST',
    name: 'Iran Standard Time',
    offset: 'UTC+03:30',
  },
  {
    abbreviation: 'IST',
    name: 'India Standard Time',
    offset: 'UTC+05:30',
  },
  {
    abbreviation: 'IST',
    name: 'Irish Standard Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'IST',
    name: 'Israel Standard Time',
    offset: 'UTC+02',
  },
  {
    abbreviation: 'JST',
    name: 'Japan Standard Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'KALT',
    name: 'Kaliningrad Time',
    offset: 'UTC+02',
  },
  {
    abbreviation: 'KGT',
    name: 'Kyrgyzstan Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'KOST',
    name: 'Kosrae Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'KRAT',
    name: 'Krasnoyarsk Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'KST',
    name: 'Korean Standard Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'LHST',
    name: 'Howe Standard Time',
    offset: 'UTC+10:30',
  },
  {
    abbreviation: 'LHST',
    name: 'Howe Summer Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'LINT',
    name: 'Line Islands Time',
    offset: 'UTC+14',
  },
  {
    abbreviation: 'MAGT',
    name: 'Magadan Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'MART',
    name: 'Marquesas Islands Time',
    offset: 'UTC-09:30',
  },
  {
    abbreviation: 'MAWT',
    name: 'Mawson Station Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'MDT',
    name: 'Mountain Daylight Time',
    offset: 'UTC-06',
  },
  {
    abbreviation: 'MET',
    name: 'Middle European Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'MEST',
    name: 'Middle European Summer Time',
    offset: 'UTC+02',
  },
  {
    abbreviation: 'MHT',
    name: 'Marshall Islands Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'MIST',
    name: 'Macquarie Island Station Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'MIT',
    name: 'Marquesas Islands Time',
    offset: 'UTC-09:30',
  },
  {
    abbreviation: 'MMT',
    name: 'Myanmar Time',
    offset: 'UTC-06:30',
  },
  {
    abbreviation: 'MSK',
    name: 'Moscow Standard Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'MST',
    name: 'Malaysia Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'MST',
    name: 'Mountain Standard Time',
    offset: 'UTC-07',
  },
  {
    abbreviation: 'MUT',
    name: 'Mauritius Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'MVT',
    name: 'Maldives Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'MYT',
    name: 'Malaysia Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'NCT',
    name: 'New Caledonia Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'NDT',
    name: 'Newfoundland Daylight Time',
    offset: 'UTC-02:30',
  },
  {
    abbreviation: 'NFT',
    name: 'Norfolk Island Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'NOVT',
    name: 'Novosibirsk Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'NPT',
    name: 'Nepal Time',
    offset: 'UTC+05:45',
  },
  {
    abbreviation: 'NST',
    name: 'Newfoundland Standard Time',
    offset: 'UTC-03:30',
  },
  {
    abbreviation: 'NT',
    name: 'Newfoundland Time',
    offset: 'UTC-03:30',
  },
  {
    abbreviation: 'NUT',
    name: 'Niue Time',
    offset: 'UTC-11',
  },
  {
    abbreviation: 'NZDT',
    name: 'New Zealand Daylight Time',
    offset: 'UTC+13',
  },
  {
    abbreviation: 'NZST',
    name: 'New Zealand Standard Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'OMST',
    name: 'Omsk Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'ORAT',
    name: 'Oral Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'PDT',
    name: 'Pacific Daylight Time',
    offset: 'UTC-07',
  },
  {
    abbreviation: 'PET',
    name: 'Peru Standard Time',
    offset: 'UTC-05',
  },
  {
    abbreviation: 'PETT',
    name: 'Kamchatka Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'PGT',
    name: 'Papua New Guinea Time',
    offset: 'UTC+10',
  },
  {
    abbreviation: 'PHOT',
    name: 'Phoenix Island Time',
    offset: 'UTC+13',
  },
  {
    abbreviation: 'PHT',
    name: 'Philippine Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'PHST',
    name: 'Philippine Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'PKT',
    name: 'Pakistan Standard Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'PIT',
    name: 'Pitcairn Time',
    offset: 'UTC-08',
  },
  {
    abbreviation: 'PMDT',
    name: 'Saint Pierre and Miquelon Daylight Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'PMST',
    name: 'Saint Pierre and Miquelon Standard Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'PONT',
    name: 'Pohnpei Standard Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'PST',
    offset: 'UTC-08',
    name: 'Pacific Standard Time',
  },
  {
    abbreviation: 'PWT',
    name: 'Palau Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'PYST',
    name: 'Paraguay Summer Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'PYT',
    name: 'Paraguay Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'RET',
    name: 'Réunion Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'ROTT',
    name: 'Rothera Research Station Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'SAKT',
    name: 'Sakhalin Island Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'SAMT',
    name: 'Samara Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'SAST',
    offset: 'UTC+02',
    name: 'South Africa Standard Time',
  },
  {
    abbreviation: 'SBT',
    name: 'Solomon Islands Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'SCT',
    name: 'Seychelles Time',
    offset: 'UTC+04',
  },
  {
    abbreviation: 'SDT',
    name: 'Samoa Daylight Time',
    offset: 'UTC-10',
  },
  {
    abbreviation: 'SGT',
    name: 'Singapore Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'SLST',
    name: 'Sri Lanka Standard Time',
    offset: 'UTC+030',
  },
  {
    abbreviation: 'SRET',
    name: 'Srednekolymsk Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'SRT',
    name: 'Suriname Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'SST',
    name: 'Samoa Standard Time',
    offset: 'UTC-11',
  },
  {
    abbreviation: 'SST',
    name: 'Singapore Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'SYOT',
    name: 'Showa Station Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'TAHT',
    name: 'Tahiti Time',
    offset: 'UTC-10',
  },
  {
    abbreviation: 'TWT',
    name: 'Taipei Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'THA',
    name: 'Thailand Standard Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'TFT',
    name: 'French Southern and Antarctic Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'TJT',
    name: 'Tajikistan Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'TKT',
    name: 'Tokelau Time',
    offset: 'UTC+13',
  },
  {
    abbreviation: 'TLT',
    name: 'East Timor Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'TMT',
    name: 'Turkmenistan Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'TRT',
    name: 'GMT+03:00',
    alias: 'Turkey Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'TOT',
    name: 'Tonga Time',
    offset: 'UTC+13',
  },
  {
    abbreviation: 'TVT',
    name: 'Tuvalu Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'ULAST',
    name: 'Ulaanbaatar Summer Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'ULAT',
    name: 'Ulaanbaatar Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'UTC',
    name: 'Coordinated Universal Time',
    offset: 'UTC±00',
  },
  {
    abbreviation: 'UYST',
    name: 'Uruguay Summer Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'UYT',
    name: 'Uruguay Standard Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'UZT',
    name: 'Uzbekistan Standard Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'VET',
    name: 'Venezuelan Standard Time',
    offset: 'UTC-04',
  },
  {
    abbreviation: 'VLAT',
    name: 'Vladivostok Time',
    offset: 'UTC+10',
  },
  {
    abbreviation: 'VOLT',
    name: 'Volgograd Standard Time',
    offset: 'UTC+03',
  },
  {
    abbreviation: 'VOST',
    name: 'Vostok Station Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'VUT',
    name: 'Vanuatu Time',
    offset: 'UTC+11',
  },
  {
    abbreviation: 'WFT',
    name: 'Wallis & Futuna Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'WAKT',
    name: 'Wake Island Time',
    offset: 'UTC+12',
  },
  {
    abbreviation: 'WAST',
    name: 'West Africa Summer Time',
    offset: 'UTC+02',
  },
  {
    abbreviation: 'WAT',
    offset: 'UTC+01',
    name: 'West Africa Standard Time',
  },
  {
    abbreviation: 'WEST',
    name: 'Western European Summer Time',
    offset: 'UTC+01',
  },
  {
    abbreviation: 'WET',
    name: 'Western European Time',
    offset: 'UTC±00',
  },
  {
    abbreviation: 'WIB',
    name: 'Western Indonesia Time',
    offset: 'UTC+07',
  },
  {
    abbreviation: 'AQTT',
    name: 'West Kazakhstan Time',
    offset: 'UTC+05',
  },
  {
    abbreviation: 'ALMT',
    name: 'East Kazakhstan Time',
    offset: 'UTC+06',
  },
  {
    abbreviation: 'WIT',
    name: 'Eastern Indonesian Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'WITA',
    name: 'Central Indonesia Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'WGST',
    name: 'West Greenland Summer Time',
    offset: 'UTC-02',
  },
  {
    abbreviation: 'WGT',
    name: 'West Greenland Time',
    offset: 'UTC-03',
  },
  {
    abbreviation: 'WST',
    name: 'Western Standard Time',
    offset: 'UTC+08',
  },
  {
    abbreviation: 'YAKT',
    name: 'Yakutsk Standard Time',
    offset: 'UTC+09',
  },
  {
    abbreviation: 'YEKT',
    name: 'Yekaterinburg Time',
    offset: 'UTC+05',
  },
];
